import IntroModal from './ui/organisms/IntroModal'
import LoadingCameraModal from './ui/organisms/LoadingCameraModal'
import NoCameraAccessModal from './ui/organisms/NoCameraAccessModal'
import { PartiallySupportedBrowserModal, UnsupportedBrowserModal } from './ui/organisms/UnsupportBrowserModals'
import MainPage from './ui/organisms/MainPage'

import LicenseErrorModal from './ui/organisms/LicenseErrorModal'
import NoCameraAvailableModal from './ui/organisms/NoCameraAvailableModal'
import LoadingModal from './ui/organisms/LoadingModal'

export function App() {
  return (
    <>
      <LoadingModal />
      <IntroModal />
      <LoadingCameraModal />
      <MainPage />
      <NoCameraAvailableModal />
      <NoCameraAccessModal />
      <UnsupportedBrowserModal />
      <PartiallySupportedBrowserModal />
      <LicenseErrorModal />
    </>
  )
}
